import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getScreenSize } from '../../../../shared/selectors/literals.selectors';
import { getDragonflyState } from '../reducers';

export const getInvoicesState = createSelector(getDragonflyState, (state) => state?.invoices);

export const getPanelExpanded = createSelector(getInvoicesState, (state) => state?.panelExpanded);

export const getInvoiceNumber = createSelector(getInvoicesState, (state) => state?.invoiceNumber);

export const getLoyaltyCard = createSelector(getInvoicesState, (state) => state?.loyaltyCard);

export const getDateFrom = createSelector(getInvoicesState, (state) => state?.dateFrom);

export const getDateFromFormat = createSelector(getInvoicesState, (state) => state?.dateFromFormat);

export const getDateFromValidation = createSelector(getDateFrom, (dateFrom) =>
  dateFrom?.toISOString() !== new Date(0).toISOString() ? dateFrom : '',
);

export const getDateUntil = createSelector(getInvoicesState, (state) => state?.dateUntil);

export const getDateUntilFormat = createSelector(
  getInvoicesState,
  (state) => state?.dateUntilFormat,
);

export const getDateUntilValidation = createSelector(getDateUntil, (dateUntil) =>
  dateUntil?.toISOString() !== new Date(0).toISOString() ? dateUntil : '',
);

export const getStoreValues = createSelector(getInvoicesState, (state) => state?.storeValues);

export const getStore = createSelector(getInvoicesState, (state) => state?.store);

export const getViewDetailsRole = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('loyaltymember.data.invoicedetails.view') ? true : false,
);

export const getCanDeleteInvoiceRole = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('invoices.action.delete') ? false : true,
);

export const getStoreValuesWithLiterals = createSelector(
  getScreenSize,
  getStoreValues,
  (literals, stores) =>
    stores?.map((store) => ({
      id: store.id,
      description: literals[store.description.toLowerCase()] || store.description,
    })) || [],
);
